import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { IClinicGroup } from 'src/app/models/clinic-group.model';
import { IError } from 'src/app/models/error.model';
import { setWarningText } from 'src/app/reducers/warning-popup.reducer';
import { ClinicGroupService } from 'src/app/services/clinic-group.service';
import { SearchService } from '../../services/search.service';

@Component({
  selector: 'app-clinic-groups',
  templateUrl: './clinic-groups.component.html',
  styleUrls: ['./clinic-groups.component.sass']
})
export class ClinicGroupsV2Component implements OnInit, OnDestroy {
  loading = false;
  groups: IClinicGroup[] = [];
  private allGroups: IClinicGroup[] = [];
  searchTerm = '';
  private subscription?: Subscription;
  private searchSubscription?: Subscription;

  // Delete modal
  showConfirmDeletePopup = false;
  groupToDelete: IClinicGroup | null = null;

  constructor(
    private clinicGroupService: ClinicGroupService,
    private router: Router,
    private searchService: SearchService,
    private store: Store<{ warningPopup: IError }>
  ) {}

  ngOnInit(): void {
    this.loadGroups();
    this.searchSubscription = this.searchService.searchTerm$.subscribe((term: string) => {
      this.searchTerm = term || '';
      this.loading = true;
      setTimeout(() => {
        this.applySearchFilter();
        this.loading = false;
      }, 200);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.searchSubscription?.unsubscribe();
  }

  loadGroups(): void {
    this.loading = true;
    this.subscription = this.clinicGroupService.getGroups().subscribe({
      next: (groups) => {
        this.allGroups = groups;
        this.applySearchFilter();
        this.loading = false;
      },
      error: (error) => {
        console.error('Erro ao buscar grupos de clínicas:', error);
        this.allGroups = [];
        this.groups = [];
        this.loading = false;
      }
    });
  }

  private applySearchFilter(): void {
    const term = (this.searchTerm || '').toLowerCase().trim();
    if (!term) {
      this.groups = this.allGroups;
      return;
    }
    this.groups = this.allGroups.filter(g =>
      (g.name || '').toLowerCase().includes(term)
    );
  }

  formatDate(dateStr?: string): string {
    if (!dateStr) return 'Não informado';
    const date = new Date(dateStr);
    return date.toLocaleDateString('pt-BR', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric'
    });
  }

  createGroup(): void {
    this.router.navigate(['main', 'v2', 'clinic-groups', 'create']);
  }

  editGroup(group: IClinicGroup): void {
    this.router.navigate(['main', 'v2', 'clinic-groups', group.id, 'edit']);
  }

  showDeleteModal(group: IClinicGroup): void {
    this.showConfirmDeletePopup = true;
    this.groupToDelete = group;
  }

  closeDeleteModal(): void {
    this.showConfirmDeletePopup = false;
    this.groupToDelete = null;
  }

  onDelete(): void {
    if (!this.groupToDelete?.id) return;

    this.loading = true;
    this.showConfirmDeletePopup = false;

    this.clinicGroupService.deleteGroup(this.groupToDelete.id).subscribe({
      next: () => {
        this.store.dispatch(setWarningText('Grupo excluído com sucesso!'));
        this.groupToDelete = null;
        this.loadGroups();
      },
      error: (error) => {
        console.error('Erro ao excluir grupo:', error);
        this.store.dispatch(setWarningText(error?.message || 'Erro ao excluir grupo.', error?.status || 500));
        this.loading = false;
        this.groupToDelete = null;
      }
    });
  }
}
